//FUNCIONS
import React, { useState, useCallback } from 'react';

//HOOKS
import { useTranslation } from '../../../hooks/useTranslation';

//TYPES

//COMPONENTS
import { MdAdd } from 'react-icons/md';
import AddressCustomer from '../../../components/AddressCustomer';

//STYLES
import {
  Container,
  Title,
  AddButton,
  ContainerAddress,
} from './styles';
import { useDispatch } from 'react-redux';
import { addressesEditRequest } from '../../../store/modules/parameter/actions';
import { UserAddresses } from '../../../store/modules/auth/types';

const AccountAddress: React.FC = () => {
  const [createdAddress, setCreatedAddress] = useState(false); // default:false
  const {onTranslation : t} = useTranslation();
  const dispatch = useDispatch();

  const handledAddresseCreate = useCallback(() => {
    dispatch(addressesEditRequest({} as UserAddresses));
    setCreatedAddress(true);
  }, [dispatch]);

  return (
    <Container>
      {
        !createdAddress && (
          <Title>
            <span>{t('main.new_account.account_address.my_address')}</span>
              <AddButton title={t('main.new_account.account_address.create_address')} onClick={handledAddresseCreate}>
                <MdAdd size={28} />
                <span>{t('main.new_account.account_address.create_address')}</span>
              </AddButton>
          </Title>
        )
      }
      <ContainerAddress>
        <AddressCustomer
          createdAddress={createdAddress}
          setCreatedAddress={setCreatedAddress}
        />
      </ContainerAddress>
    </Container>
  );
}

export default AccountAddress;
